// extracted by mini-css-extract-plugin
export default {"body":"_2-yaTEWe96wHZ8DAQPv2sJ"};